import { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import { isAnyBlank } from '../../utils/string'
import FechaSelector from '../../components/form/FechaSelector/FechaSelector'
import { dateToString } from '../../utils/date'
import AcademiaSelector from '../../components/form/AcademiaSelector/AcademiaSelector'
import TipoEventoSelector from '../../components/form/TipoEventoSelector/TipoEventoSelector'
import css from './ModalNuevoEventoCalendario.module.css'

const ModalNuevoEventoCalendario = ({ open, onSubmit, onClose }) => {
  const [data, setData] = useState({
    titulo: '',
    descripcion: '',
    fecha: null,
    centros: [],
    tipo: ''
  })

  useEffect(() => {
    if (!open) {
      setData({
        titulo: '',
        descripcion: '',
        fecha: null,
        centros: [],
        tipo: ''
      })
    }
  }, [open])

  const isSubmitDisabled = isAnyBlank(
    data.fecha,
    data.titulo,
    data.tipo,
    data.centros,
    data.descripcion
  )

  const handleSubmit = () => {
    onSubmit({
      titulo: data.titulo,
      descripcion: data.descripcion,
      fecha: dateToString(data.fecha),
      centros: data.centros,
      tipo: data.tipo
    })
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle className={css.title}>Nuevo evento</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Para crear un nuevo evento en el calendario rellena el siguiente
          formulario. El evento solo será visible en las academias que indiques.
        </DialogContentText>
        <TextField
          className={css.input}
          value={data.titulo}
          label='Título'
          onChange={e => setData({ ...data, titulo: e.target.value })}
          variant='standard'
        />
        <TipoEventoSelector
          className={css.input}
          name='tipo'
          label='Tipo de evento'
          value={data.tipo}
          onChange={e => setData({ ...data, tipo: e.target.value })}
        />
        <FechaSelector
          className={css.input}
          label='Fecha'
          value={data.fecha}
          onChange={fecha => setData({ ...data, fecha })}
        />
        <AcademiaSelector
          multiple
          className={css.input}
          name='academia'
          label='Academias'
          value={data.centros}
          onChange={e => setData({ ...data, centros: e.target.value })}
        />
        <TextField
          className={css.input}
          label='Descripción'
          multiline
          onChange={e => setData({ ...data, descripcion: e.target.value })}
          variant='standard'
        />
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cerrar
        </Button>
        <Button
          disabled={isSubmitDisabled}
          color='primary'
          onClick={handleSubmit}
        >
          Crear
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalNuevoEventoCalendario
